import { Component, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '@env/environment';
import { IonApp, IonRouterOutlet, Platform } from '@ionic/angular';
import { SplashScreen } from '@capacitor/splash-screen';
import { TranslateService } from '@ngx-translate/core';
import { LocaleService, StorageService } from '@core/services';

@Component({
  imports: [IonApp, IonRouterOutlet],
  selector: 'app-root',
  templateUrl: 'app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  isDev = !environment.production;

  constructor(
    private platform: Platform,
    private translate: TranslateService,
    private storageService: StorageService,
    // Además de elegir el idioma inicial, arranca el seguimiento del locale de moment.
    private localeService: LocaleService,
  ) {
    this.initializeTranslate();
    this.initializeApp();
  }

  loadLanguage() {
    this.storageService.get('language').then((language) => {
      if (language) {
        this.setLanguage(language as string);
      } else {
        this.setLanguage(this.localeService.browserLanguage());
      }
    });
  }

  async setLanguage(language: string) {
    this.translate.use(language);
    await this.storageService.set('language', language);
  }


  initializeTranslate() {
    this.loadLanguage();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      SplashScreen.hide();
    });
  }
}
